import { Heading3, Text } from '@lightspeed/flame/Text';
import { Box, Flex } from '@lightspeed/flame/Core';
import { LabelRequired } from '../custom/LabelRequired';
import { Autocomplete } from '../fields';
import { useTranslation } from 'react-i18next';
import useConnectionMode from '../../hooks/useConnectionMode';
import useAccounts from '../../hooks/useAccounts';
import useIsInputsOnlyLayout from '../../hooks/useIsInputsOnlyLayout';

export const MapGiftcard = () => {
  const [, softwareName] = useConnectionMode();
  const [isLoading, accountsList] = useAccounts('paymentLiability');
  const { t } = useTranslation();
  const [isInputsOnlyLayout] = useIsInputsOnlyLayout();

  return <Box padding="0.75rem">
    <Heading3 mb="0.375rem">Gift Card</Heading3>
    <Text color="gray-600" mb="1.5rem" mr="3.25rem" size="small">
        Giftcard can be mapped to an account in {softwareName}.
    </Text>
    <Flex>
      <Box width="49%" pr="1.1rem">
        <LabelRequired htmlFor="Tips">
          {
            t(isInputsOnlyLayout ? 'Enter Giftcard account' : 'Select a Gift Card account')
          } 
        </LabelRequired>
        <Autocomplete
          isLoadingOptions={isLoading}
          id="giftCard"
          name="giftCard"
          options={accountsList}
          placeholder={
            t(isInputsOnlyLayout ? 'Enter Giftcard account' : 'Select an account')
          }
        />
      </Box>
    </Flex>
  </Box>;
};
